import { merge as _merge } from 'lodash'
import ja from 'core/translations/ja'

export default _merge(ja, {
  serverError: {
    INVALID_SERIAL: 'コードが無効です。18桁である必要があります。',
    PRODUCTION_ORDER_NOT_FOUND: 'このコードに該当する生産オーダーが見つかりません。',
    STYLE_MATERIAL_COLOR_MISMATCH: 'アイテムのモデル、パーツ、または色が生産オーダーの行と一致しません。',
    SCONNECT_SHIPMENT_FAILED: 'S-Connectへの出荷の送信に失敗しました。'
  },
  otb_outbound: {
    scan_title: '生産オーダーコードをスキャン（18桁）',
    scan_code_label: 'コード',
    select_title: '生産オーダーを選択',
    header_label: '生産オーダー',
    pdf_title: 'PDFラベル',
    pdf_downloaded: '梱包ラベルをダウンロードしました',
    pdf_error: 'PDFラベルを生成またはダウンロードできません',
    pdf_parcel_unavailable: '梱包は確定されましたが、PDFラベルをダウンロードするために取得できませんでした'
  }
})
